import { BookmarkSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Bookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <BookmarkSimpleIcon size={Sizes[size]} weight="fill" {...rest} />;
};

Bookmark.displayName = 'Bookmark';
